import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addPackagesButtonLabel: {
    description: 'Add package button label',
    defaultMessage: 'Add Package',
    id: 'nQERjm',
  },
  addPackageTooltip: {
    description: 'Add package tooltip',
    defaultMessage: 'Add Package',
    id: 'VewU3p',
  },
  editPackagesButtonLabel: {
    description: 'Edit packages button label shown after multi-box packing recommendation is applied',
    defaultMessage: 'Edit Packages',
    id: 'OPYsSJ',
  },
  multiPackageButtonTooltip: {
    description: 'Tooltip for the multi-package allocation button in the shipment items section header',
    defaultMessage: 'Ship items together in multiple packages. Use when items need separate boxes due to size or weight.',
    id: 'rGR/8N',
  },
});
